import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { logout } from './authSlice';
import api from './config';

const initialState = {
  reservations: [],
  recordsTotal: 0,
  loading: false,
  updating: false,
  errors: []
};

export const fetchCompanyReservations = createAsyncThunk(
  'reservations/fetchCompany',
  async ({ companyId, ...params }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.get(`/reservations/company/${companyId}`, { params });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) dispatch(logout());
      return rejectWithValue(error.response?.data || error);
    }
  }
);

export const updateReservationStatus = createAsyncThunk(
  'reservations/updateStatus',
  async ({ reservationId, status }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.patch(`/reservations/${reservationId}/status`, { status });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) dispatch(logout());
      return rejectWithValue(error.response?.data || error);
    }
  }
);

const reservationSlice = createSlice({
  name: 'reservations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyReservations.pending, (state) => {
        state.loading = true;
        state.errors = [];
      })
      .addCase(fetchCompanyReservations.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.reservations = payload?.data || [];
        state.recordsTotal = payload?.recordsTotal || 0;
      })
      .addCase(fetchCompanyReservations.rejected, (state, { payload }) => {
        state.loading = false;
        state.errors = payload;
      })
      .addCase(updateReservationStatus.pending, (state) => {
        state.updating = true;
      })
      .addCase(updateReservationStatus.fulfilled, (state, { payload }) => {
        state.updating = false;
        const idx = state.reservations.findIndex((r) => r._id === payload._id);
        if (idx !== -1) state.reservations[idx] = payload;
      })
      .addCase(updateReservationStatus.rejected, (state, { payload }) => {
        state.updating = false;
        state.errors = payload;
      });
  }
});

export default reservationSlice.reducer;
